export default __webpack_public_path__ + "static/media/bean-designs.0b5ad1d6.webp";